import { CreateInterestPointPayload, InterestPoint, InterestPointPageResponse } from "../types/interestPoints";
import api from "./index";
import { parsePoiCategory } from "src/utils/parsePoiCategory";

export const createInterestPoint = async (data: CreateInterestPointPayload): Promise<InterestPoint> => {
  const res = await api.post("/v1/pois", data);
  return res.data.data.result;
};

export const updateInterestPoint = async (id: number, data: CreateInterestPointPayload): Promise<InterestPoint> => {
  const res = await api.put(`/v1/pois/${id}`, data);
  return res.data.data.result;
};

export const getAllInterestPoints = async (search = "", page = 0, size = 30): Promise<InterestPointPageResponse> => {
  const response = await api.get<InterestPointPageResponse>(`/v1/pois/page`, {
    params: {
      search,
      page,
      size,
    },
  });

  const parsedData = {
    ...response.data,
    content: response.data.content.map((poi) => ({
      ...poi,
      categoria: parsePoiCategory(poi.categoria),
    })),
  };

  return parsedData;
};

export const getInterestPointById = async (id: number): Promise<InterestPoint> => {
  const res = await api.get(`/v1/pois/${id}`);
  const parsedData = {
    ...res.data.data.result,
    categoria: parsePoiCategory(res.data.data.result.categoria),
  };
  return parsedData;
};

export const deleteInterestPoint = async (id: number) => {
  const response = await api.delete(`/v1/pois/${id}`);
  return response.data;
};
